// EmployeeList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { viewerDisabledProps, isViewer } from "../utils/permissions";

const EmployeeDeleteList = () => {
  const [employees, setEmployees] = useState([]);
  const [employeeName, setEmployeeName] = useState('');
  const [employeeCode, setEmployeeCode] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [initialEmployees, setInitialEmployees] = useState([]);
  const [searchField, setSearchField] = useState("name");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editEmployee, setEditEmployee] = useState(null);
  const [editExitDate, setEditExitDate] = useState('');

  useEffect(() => {
    axios
      .get(
        "https://ims-attendanceback.indevconsultancy.in/api/inactive-employees/"
      )
      .then((response) => {
        if (response.data.status) {
-          setEmployees(response.data.employees);
-          setInitialEmployees(response.data.employees);
+          setEmployees(response.data.inactive_employees);
+          setInitialEmployees(response.data.inactive_employees);
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, []);


  const handleEdit = (id) => {
    alert(`Edit employee with ID: ${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      const updated = employees.filter((emp) => emp.empdetailsid !== id);
      setEmployees(updated);
      setInitialEmployees(updated);
    }
  };

  const handleSearch = () => {
    let filtered = initialEmployees;

    if (employeeName.trim() !== '') {
      filtered = filtered.filter((emp) =>
        emp.emp_name?.toLowerCase().includes(employeeName.trim().toLowerCase())
      );
    }

    if (employeeCode.trim() !== '') {
      filtered = filtered.filter((emp) =>
        emp.employee_code?.toLowerCase().includes(employeeCode.trim().toLowerCase())
      );
    }

    if (mobileNumber.trim() !== '') {
      filtered = filtered.filter((emp) =>
        emp.emp_mobile_no?.toString().includes(mobileNumber.trim())
      );
    }

    setEmployees(filtered);
    setCurrentPage(1);
  };
  const handleReset = () => {
    setEmployeeName('');
    setEmployeeCode('');
    setMobileNumber('');
    setEmployees(initialEmployees);
    setCurrentPage(1);
  };
  const handleEditSave = async () => {
    try {
      const response = await axios.put(
        `https://ims-attendanceback.indevconsultancy.in/api/update-exit-date/${editEmployee.empdetailsid}/`,
        { date_of_exiting: editExitDate && editExitDate.trim() !== '' ? editExitDate : null }
      );
      if (response.data.status) {
        // Remove employee from list if exit date was cleared
        if (!editExitDate) {
          const updated = employees.filter(emp => emp.empdetailsid !== editEmployee.empdetailsid);
          setEmployees(updated);
          setInitialEmployees(updated);
        }
        setShowEditModal(false);
      }
    } catch (error) {
      console.error("Error updating exit date:", error);
    }
  };
  const handleDownloadExcel = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const kitchen_id = user?.kitchen || "";

    const url = `https://ims-attendanceback.indevconsultancy.in/api/create-inactive-employee-excel/?kitchen_id=${kitchen_id}`;

  // Open download link
    window.open(url, "_blank");
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employees.length / itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100%" }}>
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-start mb-0">
              <li className="breadcrumb-item">
                Delete Employee List
              </li>
            </ol>
          </nav>
        </div>

        {/* Right: Page Title */}
        <div className="col-md-6 col-6 text-end">
          <span className="">Kitchen List</span>
        </div>
      </div>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Delete Employee List</h5>
        </div>
        <div className="card-body">
          <div className="d-flex flex-md-row flex-column align-items-stretch gap-2 mb-3">
            <div className="flex-grow-1 flex-basis-0">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Employee Name"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
              />
            </div>

            <div className="flex-grow-1 flex-basis-0">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Employee Code"
                value={employeeCode}
                onChange={(e) => setEmployeeCode(e.target.value)}
              />
            </div>

            <div className="flex-grow-1 flex-basis-0">
              <input
                type="number"
                className="form-control"
                placeholder="Enter Mobile no."
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>

            <div className="flex-shrink-0">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>

            <div className="flex-shrink-0">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">
              Total Employees: <strong>{employees.length}</strong>
            </h6>
            <div className="d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={handleDownloadExcel}
              >
                Download Report
              </button>
              <button
                className="btn btn-primary bg-skyBlue"
                onClick={() => navigate("/employeeForm")}
                {...viewerDisabledProps()}
              >
                Add Employee
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>S.No.</th>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Father / Husband Name</th>
                  <th>Mobile Number</th>
                  <th>Date of Joining</th>
                  <th>Date of Exit</th>
                  <th>Action</th>
                  
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="8">No employees found.</td>
                  </tr>
                ) : (
                  currentItems.map((emp, index) => {
                    console.log(emp);
                    return (
                      <tr key={emp.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{emp.employee_code}</td>
                        <td>{emp.emp_name}</td>
                        <td>{emp.father_name || "-"}</td>
                        <td>{emp.emp_mobile_no}</td>
                        <td>{formatDate(emp.date_of_joining)}</td>
                        <td>{formatDate(emp.date_of_exiting)}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() =>
                              navigate(`/exitEmployeeDetails/${emp.empdetailsid}`, {
                                state: { employee: emp }
                              })
                            }
                            title="View Details"
                          >
                            <FontAwesomeIcon icon={faEye} /> View
                          </button>
                         <button
                            className="btn btn-sm btn-warning ms-1"
                            onClick={() => {
                              setEditEmployee(emp);
                              setEditExitDate(emp.date_of_exiting ? emp.date_of_exiting.split('T')[0] : '');
                              setShowEditModal(true);
                            }}
                            title={isViewer() ? "View-only role: action not allowed" : "Edit Exit Date"}
                            {...viewerDisabledProps()}
                          >
                            <FontAwesomeIcon icon={faUserPen} /> Edit
                          </button>
                          <button
                            className="btn btn-sm btn-success ms-1"
                            onClick={() =>
                              navigate("/employeeForm", { state: { rejoinFrom: emp } })
                            }
                            title={isViewer() ? "View-only role: action not allowed" : "Rejoin Employee (pre-fills Add Employee form)"}
                            {...viewerDisabledProps()}
                          >
                            <FontAwesomeIcon icon={faUserPlus} /> Rejoin
                          </button>
                        </td>

                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <nav
              className="mt-3 d-flex justify-content-center"
              aria-label="Pagination"
            >
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>
      {showEditModal && (
        <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Exit Date — {editEmployee?.emp_name}</h5>
                <button className="btn-close" onClick={() => setShowEditModal(false)} />
              </div>
              <div className="modal-body">
                <label>Date of Exit (clear to restore employee to active list)</label>
                <input
                  type="date"
                  className="form-control"
                  value={editExitDate}
                  onChange={(e) => setEditExitDate(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleEditSave} {...viewerDisabledProps()}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeDeleteList;
